<div id="full-screen-loading" [@enterAnimation] *ngIf="showLoading">
  <div class="inner-container">
    <div class="gif-container">
      <div class="spinner-border text-primary" style="width: 5rem; height: 5rem; margin-bottom: 10px" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="gotham-medium">{{ message }} <span class="hurme" [@enterAnimationOkMessage] *ngIf="loadingFinished">OK</span></p>
    </div>
  </div>
</div>